module.exports = __webpack_public_path__ + "static/media/xiaoshouzhengcejiage.9d85969b.png";